const stats = [
  { value: "12", label: "APIC Centres" },
  { value: "340+", label: "Machines Available" },
  { value: "4,820", label: "Active Innovators" },
  { value: "18,600", label: "Prototypes Delivered" },
  { value: "260+", label: "Industry Experts" },
];

export default function Stats() {
  return (
    <section className="bg-gradient-to-b from-indigo-50 to-white py-14">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-5 gap-8">
        {stats.map(({ value, label }) => (
          <div key={label}>
            <p className="text-4xl font-extrabold text-indigo-600 mb-1">{value}</p>
            <p className="text-gray-600 text-sm">{label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}